<template>
    <div class="list-group border-radius-2 no-border">
        <SessionAdvancedSearch 
            :value="filters"
            class="list-group-item sticky-top"
            @input="refresh"
        />
        <ScrollPaginator
            :data="sessions"
            :submitting="submitting"
            :filters="filters"
            @toPage="toPage"
            :maxPages="5"
            :scrollElementId="scrollElementId"
        >
            <template v-slot:item="{ item: session }">
                <SessionListItem 
                    :session="session"
                    @click="toggleSession(session)"
                    class="list-group-item"
                    :class="{ 'bg-light': value.findIndex(el => el.CompetencyTestSessionID === session.CompetencyTestSessionID) > -1}"
                />
            </template>
            <template v-slot:skeletonLoader>
                <SkeletonRow />
            </template>
        </ScrollPaginator>
    </div>
</template>

<script>
import SessionAdvancedSearch from './SessionAdvancedSearch.vue';
import ScrollPaginator from "src/components/Table/ScrollPaginator.vue"
import SkeletonRow from '../Table/SkeletonRow.vue';
import SessionListItem from './SessionListItem.vue';

export default {
    components: {
        SessionAdvancedSearch,
        ScrollPaginator,
        SkeletonRow,
        SessionListItem
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        scrollElementId: {
            type: String,
            default: 'main',
        }
    },
    mounted() {
        const promise = this.fetchSessions()
        if (promise) promise.then(() => { this.loading = false })
    },
    data() {
        return {
            loading: true,
            submitting: false,
            sessions: [],
            filters: {
                page: 1,
                page_size: 30,
                total: 0,
                search: '',
                students: [],
				teachers: [],
				programme: null,
				year: null,
				group: null,
				haspassed: null,
				marked: null,
				filter: null,
				test: null,
				datefrom: null,
				dateto: null,
            },
        }
    },
    methods: {
        fetchSessions() {
            if (this.submitting) return
            this.submitting = true

            this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/list`, {
                method: 'POST',
                data: {
                    ...this.filters,
                    pg: this.filters.page,
                    q: this.filters.search,
                    test: this.filters.test ? this.filters.test.id : null,
                    filter: this.filters.filter ? this.filters.filter.id : null,
                    programme: this.filters.programme ? this.filters.programme.Id : null,
                    teacher: this.filters.teachers,
                    student: this.filters.students,
                }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching treatment sessions')

                this.sessions = res.results
                this.filters.page = Number(res.pagination.page)
                this.filters.total = Number(res.pagination.total)
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-test-sessions'),
                })
            }).finally(() => {
                this.submitting = false
            })
        },
        toggleSession(session) {
            const index = this.value.findIndex(el => el.CompetencyTestSessionID === session.CompetencyTestSessionID)
            if (index > -1) this.value.splice(index, 1)
            else this.value.push(session)
            
            this.$emit('input', this.value)
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.fetchSessions()
        },
        refresh(filters) {
            this.filters = { 
                ...this.filters, 
                ...filters,
                page: 1,
            }
            this.fetchSessions()
        }
    },
}
</script>